import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

import SupportTarget from "@/types/SupportTarget";
import { computed, defineComponent, nextTick, ref, watch } from "vue";
import { useAccountStore } from '@/stores/accountProfile'
import TwoColumn from "./TwoColumn.vue";
import HandWithFingerprint from "./HandWithFingerprint.vue";
import { isArray, isEmptyObject, toCamelCase } from '../plugins/common';
import { defaultFingerprint, FINGERS, FingerStatus, HANDS } from "@/types/FingerStatus";


const serverUrl = 'http://localhost:8005';

export default /*#__PURE__*/_defineComponent({
  ...{
    name: 'SupportObject',
    components: { TwoColumn, HandWithFingerprint, },

},
  __name: 'SupportObject',
  props: {
    id: {
        type: String,
        default: '',
    }, 
    target: {
        type:SupportTarget,
        required: false,
    },
    fixedData: {
        type: Object,
        required: false,
    },
    parentContext: {
        type: Array,
        default: [],
    },
    title: String
},
  setup(__props) {

const props = __props;

const store = useAccountStore();
const srcBaseUrl = `${serverUrl}/reports/support/`;
const specialFields = ['object_extension','object_extfield'];
// let selectedFields = []; // TODO: filter fields/columns (remember filter in visibleItem)

let targetsAvailable: any[];
const extended = ref([] as SupportTarget[]);




const pageStart = ref(0);
const pageStop = ref(3);
const type = ref('');
const loading = ref(true);
const firstLoad = ref(true);
const selectedTab = ref('' as string);
const options = ref({});
const fullData = ref({default: []} as any);
const html_tabs = ref(0);
let headersSelected: any;
let defaultContext: string = 'default';
const headers = computed({
    get: () => {
        return headersSelected;
    },
    set: (value) => {
        if (value == null && items().value.length > 0) {
            headersSelected = Object.keys(items().value[0]);
            return;
        }
        headersSelected = value;
    },
});

const url = computed(() => `${serverUrl}${props.target?.endpoint || 'bad-url'}`);
const id = computed(() => (props.id ? props.id : `${props.target?.id || 'bad-id'}`));
const title = computed(() => (props.title ? props.title : '' /*`${props.target.desc}`*/));
const visibleItems = (context: string = 'default') => items(resolveContext(context)).map((item: object) => visibleItem(item));
const itemKeys = computed(() => Object.keys(fullData.value));

const items = (context: string = 'default') => fullData.value[resolveContext(context)];
const targets = (context: string = 'default'): SupportTarget[] => items(resolveContext(context)) ? items(resolveContext(context))['object_extension'] : [];

const fingerprint = ref(defaultFingerprint());

const visibleItem = (item: object) => 
    Object.assign({}, item, specialFields.reduce((accumulator, field) => {
        return {...accumulator, [field]: undefined};
    }, {})
);
const isVisibleItem = (key: string) => !specialFields.includes(key);

const resolveContext = (context: string) => {
    return (context == 'default') ? defaultContext : context;
}
const printContext = (context:any) => {console.log([context, ...props.parentContext]); return false;}

const refreshItems = async function() {
    loading.value = true;
    const dataPromise = (props.fixedData) 
        ? Promise.resolve(props.fixedData) 
        : store.searchSupport(props.id.toString(), props.target!.endpoint!);
    return dataPromise
    .then((result: any) => {
        console.log('Support result:', result);
        fullData.value = {default: []};
        if (result && result.length !== undefined) {
            defaultContext = 'default';
            fullData.value['default'] = result;    
        } else if (typeof result === 'object') {
            fullData.value = result;
            defaultContext = (result?.account) ? 'account' : Object.keys(result)[0];
        } else {
            if (props.fixedData) {
                console.error('SupportObject Error: Invalid fixed support object', result);
                throw new Error('Invalid fixed support object for: '+props.id);
            } else {
                console.error('SupportObject Error: Invalid support response', result);
                throw new Error('Search support returned invalid result for: '+props.target!.endpoint);
            }
        }
        return fullData.value;
    })
    .catch(err => {
        console.error(err);
        throw err;
    })
    .finally(() => {
        if (firstLoad.value) { firstLoad.value = false; }
        console.log('data is loaded');
        loading.value = false;
        selectedTab.value = resolveContext('default');
    })
}

const tabTitle = function(context: string) {
    if (context.startsWith('ext_')) return items(context).desc
    if (props.parentContext && props.parentContext[0] && props.parentContext[0] === 'students' && items(context)?.account?.object_resume && items(context)?.student?.object_resume) return `${items(context).account.object_resume} (${items(context).student.object_resume})`;
    return toCamelCase(context,true);
}

const tabClass = function(context: string) {
    if (context.startsWith('ext_') && selectedTab.value == context) return 'pr-0';
    if (props.parentContext && props.parentContext[0] && props.parentContext[0] === 'students' && items(context)?.student?.status) return `profile-${items(context).student.status}`;
    return '';
}

const removeTab = function(name:string) {
    // if isn't last, select next, else select previous
    const _idx = itemKeys.value.findIndex(k => k === name);
    if (_idx >= 0 && selectedTab.value === name) {
        delete fullData.value[name];
        //delete extended.value[]
        console.log('pre',selectedTab.value)
        selectedTab.value = itemKeys.value.length > _idx ? itemKeys.value[_idx] : itemKeys.value[_idx - 1];
        html_tabs.value += 1; // force re-render
        console.log('post',selectedTab.value);
    }
}

const extendAction = function(context:string, target:SupportTarget, jumpToTab: boolean = true) {
    //   this.$emit('extend',context,target) 
    let _ext = extended.value.findIndex(elem => elem.endpoint == target.endpoint)
    if (_ext == -1) {
        extended.value.push(target)
        _ext = extended.value.length -1;
    }
    fullData.value[`ext_${extended.value.length}`] = target;
    if (jumpToTab) {
        selectedTab.value = `ext_${extended.value.length}`;
    }
}

/// FINGERPRINT HANDS COMPONENT // BEGIN
const buildFingerprint = (fingers: any, hand_id: HANDS, finger_id: FINGERS) => {
    if (fingers !== undefined) {
        const finger = fingers.find((f:any) => f.hand_id === hand_id && f.finger_id === finger_id);
        if (finger) {
            fingerprint.value[hand_id][finger_id] = FingerStatus.fromSupportRow(finger);
        }
    }
};

const buildFingerprints = (): boolean => {
    fingerprint.value = defaultFingerprint();
    const fingers = items('fingerprint');
    Object.values(HANDS).filter((v) => !isNaN(Number(v))).forEach(hand => {
        Object.values(FINGERS).filter((v) => !isNaN(Number(v))).forEach(finger => {
            buildFingerprint(fingers, Number(hand), Number(finger));
        });
    });
    return true;
};
watch(fullData, (currentValue, oldValue) => {
        if (currentValue?.fingerprint && currentValue.fingerprint != oldValue?.fingerprint) {
            buildFingerprints();
        }
    },
    {
        deep: true 
    }
);
/// FINGERPRINT HANDS COMPONENT // END

watch(options, (currentValue, oldValue) => {
    refreshItems();
},
{
    deep: true 
});

headers.value = [];
refreshItems();


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_support_object = _resolveComponent("support-object", true)!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { "grid-list-xs": "" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header", {
        title: title.value,
        url: url.value,
        target: __props.target
      }, () => [
        (title.value)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(title.value), 1))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "default", {
        contexts: itemKeys.value,
        fullData: fullData.value
      }, () => [
        (_openBlock(), _createBlock(_component_v_tabs, {
          modelValue: selectedTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTab).value = $event)),
          "bg-color": "gray-lighten-2",
          key: html_tabs.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemKeys.value, (context, index) => {
              return (_openBlock(), _createBlock(_component_v_tab, {
                key: context,
                value: context,
                title: tabTitle(context),
                class: _normalizeClass(tabClass(context))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(toCamelCase)(context,true)) + " ", 1),
                  (context.startsWith('ext_') && selectedTab.value == context)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        icon: "",
                        onClick: ($event: any) => (removeTab(context)),
                        variant: "plain",
                        size: "x-small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { "x-small": "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["value", "title", "class"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_window, {
          modelValue: selectedTab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemKeys.value, (context, index) => {
              return (_openBlock(), _createBlock(_component_v_window_item, {
                key: index,
                value: context
              }, {
                default: _withCtx(() => [
                  (context.startsWith('ext_'))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (selectedTab.value==context)
                          ? (_openBlock(), _createBlock(_component_support_object, {
                              key: 0,
                              target: items(context),
                              id: items(context).id,
                              title: items(context).desc
                            }, null, 8, ["target", "id", "title"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (printContext(context) || [context, __props.parentContext ? __props.parentContext[0] : ''].includes('students'))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (selectedTab.value==context)
                            ? (_openBlock(), _createBlock(_component_support_object, {
                                key: 0,
                                id: context,
                                title: items(context).account ? `${items(context).account.object_resume}` : '',
                                "fixed-data": items(context),
                                "parent-context": [context, ...__props.parentContext]
                              }, null, 8, ["id", "title", "fixed-data", "parent-context"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (context === 'fingerprint')
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(([_unref(HANDS).LEFT, _unref(HANDS).RIGHT] as HANDS[]), (currentHand) => {
                                return (_openBlock(), _createBlock(_component_v_col, null, {
                                  default: _withCtx(() => [
                                    _createVNode(HandWithFingerprint, {
                                      title: `${_unref(FingerStatus).handFromId(currentHand)} hand`,
                                      hand: currentHand,
                                      status: fingerprint.value[currentHand]
                                    }, null, 8, ["title", "hand", "status"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 256))
                            ]),
                            _: 1
                          }))
                        : (items(context) && !(_unref(isArray)(items(context)) && items(context).length == 0) && !_unref(isEmptyObject)(items(context)))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _renderSlot(_ctx.$slots, "targets", {}, () => [
                                (targets(context)?.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      class: "bg-white pt-3 pl-3 pr-3"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targets(context), (target) => {
                                          return (_openBlock(), _createBlock(_component_v_btn, {
                                            key: target.endpoint,
                                            color: "primary",
                                            title: `Open Extension: ${target.desc}`,
                                            onClick: [
                                              ($event: any) => (extendAction(context, target)),
                                              _withModifiers(($event: any) => (extendAction(context, target, false)), ["ctrl"])
                                            ],
                                            class: "ma-1"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(target.desc), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title", "onClick"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _createVNode(TwoColumn, {
                                inputData: items(context),
                                title: "",
                                isVisibleItem: isVisibleItem
                              }, null, 8, ["inputData"])
                            ], 64))
                          : (_openBlock(), _createBlock(_component_v_alert, {
                              key: 4,
                              text: loading.value ? 'Fetching data' : 'No available data',
                              type: loading.value ? 'info' : 'warning'
                            }, null, 8, ["text", "type"]))
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 3
        }, 8, ["modelValue"])
      ]),
      _renderSlot(_ctx.$slots, "footer")
    ]),
    _: 3
  }))
}
}

})